import { HistoryFiltersConfig } from '../../configuration'

/**
 * Array of attribute names to display in the Attributes filter for Soccer.
 * These names will be matched dynamically against incident attributes from the sport API data.
 */
export const historyFiltersAttributesConfig: HistoryFiltersConfig['historyFiltersAttributes'] =
  [
    'No assist',
    'Retaken',
    'Causes penalty',
    'Big chance successful',
    'Big chance missed',
    'Empty net',
    'Uncomfortable position',
    'Goalline clearance',
    'Goalkeeper involvement',
    'Easy save',
    'Important save',
    'Spectacular save',
    'Direct free kick',
    'Normal',
    'First touch',
    'Head',
    'Volley',
    'Bicycle kick',
    'Other body part',
    'No pressure',
    'Light pressure',
    'High pressure',
    'Clear position',
    '1 defender',
    '2 or more defenders',
    'Leading to attempt',
    'Leading to goal',
    'One on one',
    'Power shot',
    'Chip',
    'Shot woodwork',
    'Crossbar',
    'Post',
    'Left foot',
    'Right foot',
    'Inside penalty area',
    'Outside penalty area',
    'Upper left',
    'Upper middle',
    'Upper right',
    'Bottom left',
    'Bottom middle',
    'Bottom right',
    'Own goal',
    'Penalty goal',
    'Second yellow card',
    'Off-field',
    'Dangerous free kick',
    'Possible goal',
    'Possible penalty',
    'Possible red card',
    'Handball',
    'Tactical foul',
    'Serious foul',
    'Dangerous play',
    'Unsporting behaviour',
    'Referee abuse & argument',
    'Violent conduct',
    'Diving',
    'Time wasting',
    'Permanent',
    'Temporary',
    'Excessive celebration',
    'Open play',
    'Fast break',
    'Set piece',
    'Blocked by teammate',
    'Last line',
  ]
